(() => {
  const root = document.documentElement;
  const desktop = window.matchMedia('(min-width: 1025px)');
  const compactClass = 'mcocod-header-compact';
  let frame = 0;
  let expandedHeight = 0;

  const getHeader = () => document.querySelector('.t4s-is-header-categories-menu');

  const measureExpandedHeight = () => {
    const header = getHeader();
    if (!header || root.classList.contains(compactClass)) return;
    expandedHeight = header.getBoundingClientRect().height || expandedHeight;
  };

  const exitCompact = () => {
    if (root.classList.contains(compactClass)) root.classList.remove(compactClass);
    root.style.removeProperty('--mcocod-header-placeholder-height');
  };

  const enterCompact = () => {
    const header = getHeader();
    if (!header || root.classList.contains(compactClass)) return;
    root.style.setProperty('--mcocod-header-placeholder-height', `${expandedHeight || header.getBoundingClientRect().height}px`);
    root.classList.add(compactClass);
  };

  const sync = () => {
    frame = 0;
    if (!desktop.matches) {
      exitCompact();
      return;
    }

    const compact = root.classList.contains(compactClass);
    const themeIsStuck = root.classList.contains('is-header--stuck');
    if (!compact && themeIsStuck) enterCompact();
    if (compact && !themeIsStuck) exitCompact();
  };

  const requestSync = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(sync);
  };

  const handleResize = () => {
    if (!root.classList.contains('is-header--stuck')) measureExpandedHeight();
    requestSync();
  };

  const handleSectionChange = () => {
    exitCompact();
    measureExpandedHeight();
    requestSync();
  };

  window.addEventListener('resize', handleResize, { passive: true });
  desktop.addEventListener?.('change', requestSync);
  document.addEventListener('shopify:section:load', handleSectionChange);
  document.addEventListener('shopify:section:unload', handleSectionChange);
  new MutationObserver(requestSync).observe(root, { attributes: true, attributeFilter: ['class'] });
  measureExpandedHeight();
  requestSync();
})();
